import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Overview } from './pages/Overview';
import { NCJI } from './pages/NCJI';
import { Contact } from './pages/Contact';
import { Constitution } from './pages/Constitution';
import { ConstitutionalPrinciples } from './pages/ConstitutionalPrinciples';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { About } from './pages/About';
import { TransitionAct } from './pages/TransitionAct';
import { HumanCapabilityEngine } from './pages/HumanCapabilityEngine';
import { Pillars } from './pages/Pillars';
import { SovereignTrade } from './pages/SovereignTrade';
import { TravelProtocol } from './pages/TravelProtocol';
import { FoundingCharter } from './pages/FoundingCharter';
import { Manifesto } from './pages/Manifesto';
import { LanguageOfAlignment } from './pages/LanguageOfAlignment';
import { Footer } from './components/Footer';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-cognarch-white text-cognarch-gray font-sans selection:bg-cognarch-black selection:text-white" data-id="element-2">
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/overview" element={<Overview data-id="element-9" />} data-id="element-8" />
            <Route path="/charter" element={<Manifesto data-id="element-11" />} data-id="element-10" />
            <Route path="/ncji" element={<NCJI data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<Contact data-id="element-15" />} data-id="element-14" />
            <Route path="/constitution" element={<Constitution data-id="element-17" />} data-id="element-16" />
            <Route path="/principles" element={<ConstitutionalPrinciples data-id="element-19" />} data-id="element-18" />
            <Route path="/privacy" element={<PrivacyPolicy data-id="element-21" />} data-id="element-20" />
            <Route path="/terms" element={<TermsOfService data-id="element-23" />} data-id="element-22" />
            <Route path="/about" element={<About data-id="element-25" />} data-id="element-24" />
            <Route path="/transition" element={<TransitionAct data-id="element-27" />} data-id="element-26" />
            <Route path="/capability" element={<HumanCapabilityEngine data-id="element-29" />} data-id="element-28" />
            <Route path="/pillars" element={<Pillars data-id="element-31" />} data-id="element-30" />
            <Route path="/sovereign-trade" element={<SovereignTrade data-id="element-33" />} data-id="element-32" />
            <Route path="/travel-protocol" element={<TravelProtocol data-id="element-35" />} data-id="element-34" />
            <Route path="/founding-charter" element={<FoundingCharter data-id="element-37" />} data-id="element-36" />
            <Route path="/language-of-alignment" element={<LanguageOfAlignment data-id="element-39" />} data-id="element-38" />
          </Routes>
        </main>
        <Footer data-id="element-40" />
      </div>
    </BrowserRouter>;
}